<div class="app-wrapper sp-main-wrapper" spAppTheme>
  <ng-container *cbreTogglePoint="'stackingPlanPropertyView'">
    <div class="flex-container mt-sm sp-view-toolbar item-flex-end">
      <!-- Property Type Selection-->
      <div class="item flex-h-alignment flex-a-center tabnav-wrapper">
        <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="edit-tabnav">
          <ng-container *ngFor="let link of propertyTypes">
            <span
              matTooltip="{{ link.tooltip | xTranslate }}"
              matTooltipClass="tooltip-action-icon"
              matTooltipPosition="above"
            >
              <a
                mat-tab-link
                [active]="selectedPropertyType() == link.key"
                (click)="setPropertyType(link.key)"
                [class.custom-disabled]="!link.hasAccess"
              >
                {{ link.value }}
              </a>
            </span>
          </ng-container>
        </nav>
        <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
      </div>

      <!-- View Toggle -->
      <div class="item flex-h-alignment flex-a-center item-flex-end mb-5 prop-view-wrapper">
        <mat-button-toggle-group
          id="e2e-stackView"
          class="item-flex-end sp-view-selector"
          name="stackView"
          aria-label="Stacking View"
          [(ngModel)]="stackView"
          (change)="propertyViewChange($event.value)"
          hideSingleSelectionIndicator
        >
          <!-- Stacking Plan View -->
          <mat-button-toggle
            class="toggle-button"
            [value]="STACK_VIEWS.Default"
            [matTooltip]="'spaceDetailTooltip' | xTranslate"
            matTooltipClass="tooltip-action-icon"
            matTooltipPosition="above"
          >
            {{ 'spaceDetailTitle' | xTranslate }}
          </mat-button-toggle>

          <!-- Property View -->
          <mat-button-toggle
            class="toggle-button"
            [value]="STACK_VIEWS.PropertyView"
            [matTooltip]="'stackOverviewTooltip' | xTranslate"
            matTooltipClass="tooltip-action-icon"
            matTooltipPosition="above"
          >
            {{ 'stackOverviewTitle' | xTranslate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </ng-container>

  <ng-container [ngSwitch]="stackView">
    <!-- Property View (PV)  -->
    <ng-container *ngSwitchCase="STACK_VIEWS.PropertyView">
      <sp-property-view [building]="buildingData"></sp-property-view>
    </ng-container>

    <!-- Stacking Plan -->
    <ng-container *ngSwitchDefault>
      <sp-stacking-plan-container
        class="stacking-plan-container"
        *ngIf="stackingPlanDataLoaded"
        [reviewerData]="reviewerData"
        (createNewRecord)="newRecordCreationRoute($event)"
      ></sp-stacking-plan-container>
    </ng-container>
  </ng-container>
</div>
